export default __webpack_public_path__ + "static/coveInUseMobile-47a321eb2678db31e7d4f1165d2b1b33.jpg";